import styled from '@emotion/styled';
import { ShopTypes } from '~/lib/data-contract';
import { useTranslations } from '~/services/umbraco/hooks';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';
import DeliveryMethod from '../../M200OrderHistory/components/DeliveryMethod';
import DeliveryStatus from '../../M200OrderHistory/components/DeliveryStatus';

type Props = {
    data: ShopTypes.OrderDetailsResponse;
};

export default function OrderDetailsInformation({ data }: Props) {
    const { translate } = useTranslations();
    return (
        <OrderDetailsContainer>
            <div>
                <dt>
                    <Text variant="display6">{translate('mit-fog.orderDetails.date')}</Text>
                </dt>
                <dd>
                    <Text>
                        {data.orderDate ? new Date(data.orderDate).toLocaleDateString() : '-'}
                    </Text>
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">{translate('mit-fog.orderDetails.number')}</Text>
                </dt>
                <dd>
                    <Text>{data.orderNumber ?? '-'}</Text>
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">
                        {translate('mit-fog.orderDetails.customersReference')}
                    </Text>
                </dt>
                <dd>
                    <Text>{data.customersReference ?? '-'}</Text>
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">{translate('mit-fog.orderDetails.customerId')}</Text>
                </dt>
                <dd>
                    <Text>{data.customerNumber ?? '-'}</Text>
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">{translate('mit-fog.orderDetails.status')}</Text>
                </dt>
                <dd>{data.status ? <DeliveryStatus noIndicator status={data.status} /> : '-'}</dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">
                        {translate('mit-fog.orderDetails.deliveryMethod')}
                    </Text>
                </dt>
                <dd>
                    {data.deliveryMethod ? <DeliveryMethod method={data.deliveryMethod} /> : '-'}
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">
                        {translate('mit-fog.orderDetails.invoiceAddress')}
                    </Text>
                </dt>
                <dd>
                    <Text>{data.invoiceAddress?.addressLine1 ?? '-'}</Text>
                </dd>
            </div>
            <div>
                <dt>
                    <Text variant="display6">
                        {translate('mit-fog.orderDetails.deliveryAddress')}
                    </Text>
                </dt>
                <dd>
                    <Text>{data.deliveryAddress?.addressLine1 ?? '-'}</Text>
                </dd>
            </div>
        </OrderDetailsContainer>
    );
}

const OrderDetailsContainer = styled.dl(({ theme }) => ({
    borderTop: `1px solid ${theme.colors.nightBlack}`,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: theme.space[4],
    paddingTop: theme.space[4],
    marginBottom: theme.space[5],
    [breakpoints.sm]: {
        marginBottom: theme.space[8],
        gridTemplateColumns: 'repeat(4, 1fr)',
    },
}));
